import React, { useState , useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import "@fontsource/mulish"; // Defaults to weight 400.

import LoadingButton from '@mui/lab/LoadingButton';

import TextField from '@mui/material/TextField';

import { makeStyles } from '@mui/styles';

import InvoiceMainView from './InvoiceMainView';
import Contacts from './Contacts';
import LinkedAccounts from './LinkedAccounts';
import UserManagement from './UserManagement';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/pro-regular-svg-icons";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomerSearch from './CustomerSearch';



import {getConfigValue} from './Config';






const useStyles = makeStyles(theme => ({
  customerSearchColumn: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    backgroundColor : '#F3F3F3',
    padding: '.5em',
    fontSize: 14,   
    borderRadius: '3px' ,
 
    marginTop: '.3em',
    marginLeft: '.5em',
   },

   customerSearchRow: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'space-between',
    alignItems: 'flex-start',  
    flexWrap: 'wrap',
    // flexBasis: '100%',
    // height: '0',

   },

  textField : {
    width: '100px', 
    fontSize: '8pt'
  }, 
  customerSearchButton: {
    marginLeft: '1em', 
    marginTop: '.3em',
   
  }, 
  usersList: {
    overflow: 'auto',
    maxHeight: 100,
  },

  customerInfo: {
     fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    backgroundColor : '#F3F3F3',
    padding: '0em',
    fontSize: 14,   
    borderRadius: '3px' ,
 
    marginTop: '.3em',
    marginLeft: '0em',
  }, 
  customerInfoElement: {
    marginRight: '0.5em',
    marginTop: '.5em',
  },
  customerInfoNameElement: {
    fontSize: '16pt',
    marginRight: '0.5em',
  }, 
  accordion : {
   
    marginTop: '.4em',

  }


}));



function Admin(props) {

  const [customer, setCustomer] = useState(null);
  const [doRefresh, setDoRefresh] = useState({});
  const [isMainSearchExpanded, setIsMainSearchExpanded] = useState(false);  

  //temporary admin login, to be replaced with Azure AD single sign-on
  const [pwd, setPwd] = useState('');
  const [userName, setUserName] = useState('');
  const [loginMessage, setLoginMessage] = useState('');

  const [invoiceNosForBulkExport, setInvoiceNosForBulkExport] = useState('');
  const [bulkExportResult, setBulkExportResult] = useState('');
  const [loadingButtons, setLoadingButtons] = useState({});

  
  const classes = useStyles();

  var store = require('store')
  const navigate = useNavigate();
  
  const isLoading = (buttonName) => {
    return loadingButtons[buttonName];
  }

  const setLoading =(buttonName, isLoading) => {
    var ldnButtons = {...loadingButtons};
    ldnButtons[buttonName] = isLoading;
    setLoadingButtons(ldnButtons);        
  }

  // useEffect(() =>  { //run once on page load   

  //   if (!props.isLoggedIn) //if not currently logged in, try to log in with Azure AD
  //     login();
   
    
  // },[])


  useEffect(() =>  { //run once on page load   

    // console.log('serverBaseUrl:', getConfigValue('serverBaseUrl'));

    if (props.isLoggedIn)
      getActiveCustomer(); //get the current Customer when logged in
    
  },[props.isLoggedIn, props.isAdmin])
 
  
  
  const getActiveCustomer = async () => {     
    fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/getActiveCustomer/${store.get("sessionToken")}`)    
    .then(res => res.json())
    .then(json => { 

      setCustomer(json);
      
    })
    
  };

  const onSelectCustomerToOpen = async (customer) => {      

      console.log("customer to open: ", customer);     
     
      
      const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/setActiveCustomer/${store.get("sessionToken")}/${customer.Id}`); 
      const json = await res.json();  
      
      
      if (json["errorCode"]=='240'){        
        console.log("Not logged in / session not verified");   
        navigate('../');
      }
           
      if (customer.CustomerId) { //only the first N results in a customer search is populated with CustomerId(systemId, kundeNr form idRelations) due to performance
        setCustomer(customer);
      }
      else {                      //CustomerId not present, refetch from server  
        fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/getActiveCustomer/${store.get("sessionToken")}`)    
          .then(res => res.json())
          .then(json => { 

            setCustomer(json);
        
        })
      }
      
      setDoRefresh(new Date()); //new object which triggers rerendering of the embedded InvoiceMainView component
  }

  const refreshPage =  () => {  
    setDoRefresh(new Date()); //new object which triggers rerendering of the embedded InvoiceMainView component
  }
  
  const bulkExport = async () => {  
    setLoading('bulkExport', true);
    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Invoice/prepareInvoicePDFsInBulk/${store.get("sessionToken")}/${invoiceNosForBulkExport}`);            
    const json = await res.json();   

    if (json['result']=='success') {
      setBulkExportResult(`Export finished with ${json['noOfInvoices']} exported successfully`);
      
      window.open(`${getConfigValue('serverBaseUrl')}/api/Invoice/downloadInvoicePdfsInBulk/${json['key']}`);  

      console.log(`${getConfigValue('serverBaseUrl')}/api/Invoice/downloadInvoicePdfsInBulk/${json['key']}`);  
    }
    else
      setBulkExportResult('export failed');

    
    setLoading('bulkExport', false);
    

  }


  const login = async () => {  
    
    var userNameAndPwd = {};
    userNameAndPwd.userName = userName;
    userNameAndPwd.pwd = pwd;
    
    const response = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/login/${store.get("sessionToken")}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.          
            headers: {
              'Content-Type': 'application/json'             
            },            
            body: JSON.stringify(userNameAndPwd) // body data type must match "Content-Type" header
        });

        const json = await response.json(); // parses JSON response into native JavaScript objects  
        

        if (json["result"]=='success'){                 
          console.log("Logged in as admin");                       
          props.checkLoginStatus(); //callback to Component Main, checks login status and re-renders application
        }
        else {
          setLoginMessage('Username/password is not correct.');
        }
  }



    

  return (        
    
    
    <div>      
        {/* temporary admin login form */}
        {!(props.isLoggedIn && props.isAdmin) && <div>
          <br/>
          <TextField                           
              onChange={e => setUserName(e.target.value)} 
              style={{marginLeft: '5px', marginRight: '5px'}}
              variant="outlined" label="Brukernavn" size='small'>              
          </TextField>
          <TextField         
              type='password'          
              onChange={e => setPwd(e.target.value)} 
              style={{marginRight: '5px'}}
              variant="outlined" label="Passord" size='small'>
          </TextField>
          <LoadingButton style={{marginTop: '5px'}} variant="contained" size='small' color="primary" onClick={_=>login()}>Logg inn </LoadingButton>                                
         
          <div style={{marginLeft: '5px'}}>
            <LoadingButton style={{marginTop: '5px'}} variant="contained" size='small' color="primary" onClick={_=>login()}>Logg inn med AAD </LoadingButton>                    
          
            {props.aadEmail && <div>{props.aadEmail}</div>}
            <div>{loginMessage}</div>
          </div>
          
        </div> 
        }

        {(props.isAdmin && props.isLoggedIn) && <div>

          {/* {props.isAdmin && <div>Admin Roles: {props.adminRoles} </div>} */}


          {props.adminRoles && props.adminRoles.includes('manageAdmins') && <UserManagement doRefresh={doRefresh}/> }

          {props.adminRoles && props.adminRoles.includes('bulkInvoiceFetcherRole') && <div>           
              <Accordion className={classes.accordion} style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} > 
              <AccordionSummary onClick={_=>setIsMainSearchExpanded(!isMainSearchExpanded)} style={{backgroundColor: '#F3F3F3'}}
                  expandIcon={<ExpandMoreIcon />}                  
                >     
                  Bulk Invoice Export 
              </AccordionSummary>
              
              <AccordionDetails>   
      
                <TextField
                    onChange={e => setInvoiceNosForBulkExport(e.target.value)} 
                    variant="outlined" label="InvoiceNo adskilt med komma" size='small'>
                  </TextField>
                  &nbsp;&nbsp;
                  <LoadingButton loading={isLoading('bulkExport')} style={{marginTop: '5px'}} variant="contained" size='small' color="primary" onClick={_=>bulkExport()}>Eksportér </LoadingButton>
                  {bulkExportResult && <div> {bulkExportResult} </div>}      
              </AccordionDetails>

              </Accordion>
          </div>
          }

        {/* style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} > */}
        <Accordion className={classes.accordion} style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} > 
         <AccordionSummary onClick={_=>setIsMainSearchExpanded(!isMainSearchExpanded)} style={{backgroundColor: '#F3F3F3'}}
          expandIcon={<ExpandMoreIcon />}                  
        >                  
          {customer && 
        <div className={classes.customerInfo}>  {/* current customer info */}                         
          <div className={classes.customerInfoNameElement}> <FontAwesomeIcon icon={faUser} /> </div>
          <div className={classes.customerInfoNameElement}>  {customer.DisplayName} </div>
          <div className={classes.customerInfoElement}>Type: {customer.CorporateForm} </div>     
          {customer.OrganizationNo && <div className={classes.customerInfoElement}>Organisasjonsummer: {customer.OrganizationNo} </div> }                 
          <div className={classes.customerInfoElement}>Kundenr: {customer.CustomerId} </div>                        
        </div>
        }  
        {!customer && <div>Kundesøk</div>} 
        </AccordionSummary>
         
        <AccordionDetails>   

        <CustomerSearch onSelectCustomer={onSelectCustomerToOpen}/>

        

        </AccordionDetails>
        </Accordion>

        <Contacts doRefresh={doRefresh}/>

        <LinkedAccounts doRefresh={doRefresh} refreshParent={refreshPage} customer={customer}/>

        <InvoiceMainView admin doRefresh={doRefresh} userName={props.userName}/> 
       
        
          
           
        </div>}
       
     </div>

    
 

    

  );
}






export default Admin;
